import React, { useState } from 'react';
import { useDispatch, ReactReduxContext } from 'react-redux';
import { Modal, Select, Button, Upload, message } from 'antd';
import { InboxOutlined, ImportOutlined, CheckCircleTwoTone } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import { extname } from 'path';
import asyncPool from 'tiny-async-pool';

import { csvRadStrategy } from './../../../Libs/Sheets';
import { fetchOrdersEdit } from '@/Actions/Orders';
import Concrete from '@/Libs/Orders/Import/Concrete';

const Option = Select.Option;
const Dragger = Upload.Dragger;

export default (props) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false); // debug:
  const [confirmModal, setConfirmModal] = useState(false);
  const [platform, setPlatform] = useState('31');
  const [orderLoading1, setOrderLoading1] = useState(false);
  const [orderLoading2, setOrderLoading2] = useState(false);
  const [filedata, setFiledata] = useState({});
  const _props = {
    name: 'file',
    accept: '.xlsx, .xls, .csv',
    beforeUpload: () => false,
    showUploadList: false,
    onChange(info) {
      // 通过FileReader对象读取文件
      const fileReader = new FileReader();
      let isCSV = extname(info?.file?.name || '') === '.csv' ? true : false;

      fileReader.onload = async (event) => {
        try {
          let { result } = event.target;
          if (isCSV) {
            result = csvRadStrategy(result);
          }
          const concrete = new Concrete({ platform, XLSX, result, isCSV });
          const orders = await concrete.TemplateMethod();
          console.log('file read', orders);
          // 最终获取到并且格式化后的 json 数据
          setConfirmModal(true);
          setFiledata(orders);
        } catch (e) {
          // 这里可以抛出文件类型错误不正确的相关提示
          console.log(e);
          message.error('文件类型不正确或文件解析失败！');
        }
      };
      if (isCSV) {
        fileReader.readAsArrayBuffer(info.file);
      } else {
        fileReader.readAsBinaryString(info.file);
      }
    },
  };
  const importNow = async (all = true) => {
    let senddata = [];
    if (all) {
      senddata = [...filedata.origin];
      setOrderLoading1(true);
    } else {
      const existsOrder = [...filedata.exists];
      senddata = filedata.origin.filter((r) => !existsOrder.includes(r.ordersn));
      setOrderLoading2(true);
    }
    const ordersIds = [];
    for await (const result of asyncPool(
      5,
      senddata,
      (row) => new Promise((resolve) => dispatch(fetchOrdersEdit(row)).then((r) => resolve(r.data)))
    )) {
      ordersIds.push(result);
    }
    setOrderLoading1(false);
    setOrderLoading2(false);
    setConfirmModal(false);
    message.success({ content: '导入完成!', duration: 2 });
  };
  return (
    <span style={props.style || {}}>
      <Button icon={<ImportOutlined />} onClick={() => setIsModalVisible(true)}>
        批量导入
      </Button>
      <Modal
        title="导入订单"
        visible={isModalVisible}
        onOk={() => setIsModalVisible(false)}
        onCancel={() => setIsModalVisible(false)}
      >
        <Select
          defaultValue={{ 'label': '华成美团 - 门票', 'value': '31' }}
          labelInValue={true}
          style={{ width: '100%', marginBottom: '20px' }}
          onChange={(e) => setPlatform(e.value)}
        >
          {/* <Option key="1" value="alpay">飞猪</Option> */}
          <Option key="31" value="31">
            华成美团-门票
          </Option>
          <Option key="13" value="13">
            国旅携程-玩乐
          </Option>
          <Option key="12" value="12">
            国旅携程-跟团
          </Option>
          <Option key="37" value="37">
            第五季去哪儿
          </Option>
        </Select>
        <Dragger {..._props}>
          <InboxOutlined /> 单击此区域以上传文件（.xlsx, .xls, .csv）。
        </Dragger>
      </Modal>

      <Modal
        title={
          <div>
            <CheckCircleTwoTone twoToneColor="#52c41a" /> 解析成功
          </div>
        }
        closable={false}
        visible={confirmModal}
        icon={<CheckCircleTwoTone twoToneColor="#52c41a" />}
        footer={[
          <Button key="hide" onClick={() => setConfirmModal(false)}>
            隐藏
          </Button>,
          // <Button key="all" type="primary" ghost loading={orderLoading1} onClick={importNow}>
          //   全部更新
          // </Button>,
          <Button
            key="new"
            type="primary"
            loading={orderLoading2}
            disabled={filedata?.origin?.length === filedata?.exists?.length}
            onClick={() => importNow(false)}
          >
            导入新订单
          </Button>,
        ]}
      >
        <div>共 {filedata?.origin?.length} 个订单</div>
        <div>其中 {filedata?.exists?.length} 个订单已存在</div>
      </Modal>
    </span>
  );
};
